import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import React, { useMemo } from 'react'
import { useSalonAcceptancesContext } from '../../context'

export default function SalonAcceptancesDashboard({ acceptances }: Props) {
    const { salon } = useSalonAcceptancesContext()

    const awardedCount = useMemo(() => getAwardedCount(acceptances), [acceptances])

    return (
        <Grid columns="4">
            {salon.state.sections.map((section, idx) => (
                <EmphasizedContent key={idx}>
                    <Grid gap="5px">
                        <p>{section.name}</p>
                        <Grid gap="0px">
                            <h3>{getAwardedCountBySection(section.id, awardedCount)} / {salon.attrs.awards.count()}</h3>
                            <small>awards</small>
                        </Grid>
                    </Grid>
                </EmphasizedContent>
            ))}
        </Grid>
    )
}

function getAwardedCountBySection(sectionId: number, count: Awarded): number {
    return count[sectionId] || 0
}

function getAwardedCount(acceptances: Jury.Resources.Acceptance[]) {
    const result: Awarded = {}

    for (const acceptance of acceptances) {
        if (!acceptance.award)
            continue

        result[acceptance.section.id] = (result[acceptance.section.id] || 0) + 1
    }

    return result
}

type Awarded = {
    [key: number]: number
}

interface Props {
    acceptances: Jury.Resources.Acceptance[]
}